import Vue from "vue";
import Router from "vue-router";

import HomePage from "@/views/HomeView.vue";
import NotFound from "@/views/NotFound.vue";
import About from "@/views/AboutUsView.vue";
import Services from "@/views/ServicesView.vue";
import ServicesDetails from "@/views/ServicesDetailedView.vue";
import Contact from "@/views/ContactFormView.vue";
import Blog from "@/views/BlogView.vue";
import News from "@/views/NewsView.vue";
import BlogDetails from "@/views/BlogDetailedView.vue";

Vue.use(Router);

// Detect and store country
async function detectAndStoreLocation() {
  try {
    const res = await fetch("https://ipapi.co/json/");
    const data = await res.json();
    const isUS = data.country_code === "US";
    localStorage.setItem("isUS", isUS);
    localStorage.setItem("userCountry", data.country_code);
    return isUS;
  } catch (e) {
    localStorage.setItem("isUS", "false");
    return false;
  }
}

const router = new Router({
  mode: "history",
  routes: [
    // ---------- INDIA ----------
    { path: "/", component: HomePage },
    { path: "/about", component: About },
    { path: "/services", component: Services },
    { path: "/services/:serviceName", component: ServicesDetails, props: true },
    { path: "/blog", component: Blog },
    { path: "/blog/:blogTitle", component: BlogDetails, props: true },
    { path: "/news", component: News },
    { path: "/contact", component: Contact },

    // ---------- US ----------
    { path: "/us", component: HomePage, meta: { location: "us" } },
    { path: "/us/about", component: About, meta: { location: "us" } },
    { path: "/us/services", component: Services, meta: { location: "us" } },
    {
      path: "/us/services/:serviceName",
      component: ServicesDetails,
      props: true,
      meta: { location: "us" },
    },
    { path: "/us/blog", component: Blog, meta: { location: "us" } },
    {
      path: "/us/blog/:blogTitle",
      component: BlogDetails,
      props: true,
      meta: { location: "us" },
    },
    { path: "/us/news", component: News, meta: { location: "us" } },
    { path: "/us/contact", component: Contact, meta: { location: "us" } },

    // ---------- FALLBACK ----------
    { path: "*", component: NotFound },
  ],
});

// 🔁 First-time redirect from `/` → `/us`
router.beforeEach(async (to, from, next) => {
  if (to.path === "/" && !sessionStorage.getItem("locationChecked")) {
    sessionStorage.setItem("locationChecked", "true");
    const isUS = await detectAndStoreLocation();
    if (isUS) return next("/us");
  }

  const isUS = localStorage.getItem("isUS") === "true";

  // 🔒 Enforce `/us` for all routes if user is US
  if (isUS && !to.path.startsWith("/us")) {
    return next(`/us${to.path}`);
  }

  next();
});

export default router;
